// TODO Fix everything with eslint-disable-next-line @typescript-eslint/no-redeclare
import * as types from 'types';

interface IRecordedInterview {
  [key: string]: types.IRecordedInterviewEntry & { isWidgetOpened?: boolean };
}

export type OfferState = Omit<types.IOffer, 'recordedInterviews'> & {
  recordedInterviews?: IRecordedInterview;
};

export enum CoreActionTypes {
  UPDATE_VISA_STATUS = '@@student/core/UPDATE_VISA_STATUS',
  UPDATE_OFFER_FIELD = '@@visa/core/UPDATE_OFFER_FIELD'
}

export const Status = types.CoreStatusExtended;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type Status = types.CoreStatusExtended;

export const VisaStatus = types.VisaStatus;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type VisaStatus = types.VisaStatus;

export enum EnrolmentStatusEnum {
  None = 'NoEnrolmentStatus',
  Question = 'Question',
  Wait = 'Wait',
  Cancel = 'Cancel',
  OK = 'OK',
  Defer = 'Defer',
  Withdraw = 'Withdraw'
}
